angular.module('iqxCore')
.component("iqxDatePicker",{
	templateUrl: "views/iqxDatePicker.tpl.html",
	controller: "iqxDatePickerCtrl",
	bindings: {
		iqxDate: '=',
		max:'<',
		min:'<',
    iqxDisabled:'<',
		accuracy:'@',
		placeholder:'@',
		text:'@'
	}
});